import type { FC, ReactNode } from 'react'

import { Float, Reveal } from '@/components/anim'

export const CtaSection: FC = (): ReactNode => {
    return (
        <div id='cta' className='section'>
            <div className='section overflow-hidden'>
                <div className='container'>
                    <Reveal>
                        <Float
                            as='img'
                            src='/images/Cone-3-min.webp'
                            loading='lazy'
                            alt=''
                            className='cta-cone-image'
                            x={10}
                            y={-18}
                            rotate={6}
                            duration={6}
                        />

                        <div className='cta-content'>
                            <Reveal className='cta-text-holder'>
                                <h2>Ready to get started?</h2>
                                <div className='grey-text small'>
                                    Sign up with an Ionic account or speak with an Ionic Expert
                                </div>
                                <div className='fixed-width'>
                                    <a
                                        href='mailto:hello@modulify.ai'
                                        className='button-gradient-nav non-capitalize w-inline-block'
                                    >
                                        <div>Sign up for free</div>
                                        <div className='button-gradient-bg' />
                                    </a>
                                </div>
                            </Reveal>

                            <div className='cta-app-holder'>
                                <img
                                    src='/images/Dashboard-Image.webp'
                                    loading='lazy'
                                    width={2012}
                                    height={1303}
                                    alt='Manila dashboard preview'
                                    className='cta-image'
                                />
                            </div>
                        </div>

                        <Float
                            as='img'
                            src='/images/SuperToroid-2-min.webp'
                            loading='lazy'
                            alt=''
                            className='cta-circle-image'
                            x={-8}
                            y={20}
                            rotate={-8}
                            duration={5.5}
                        />
                    </Reveal>
                </div>
            </div>
            <div className='cta-gradient-holder _404'>
                <div className='gradient-center cta' />
            </div>
        </div>
    )
}
